// Kullanıcıya özel localStorage kalıntılarını logout'ta temizler — güvenlik/UX taraması
// 2026-10-08 (S-L1). Paylaşılan tarayıcıda bir sonraki kullanıcı önceki kullanıcının KPI seçimini,
// son müşterilerini, review "yoksay" kararlarını, portal işletme seçimini ya da parti taslağını
// görmemeli. Önek listesi tek kaynak; yeni bir kullanıcı-bazlı anahtar eklerken buraya da ekle.
// Saf (StorageLike enjekte edilir — jsdom yok, period-ui kalıbı); userId'den bağımsız olarak
// öneke uyan TÜM anahtarlar silinir (eski oturumların kalıntıları da gider).

export interface KeyedStorageLike {
  readonly length: number;
  key(index: number): string | null;
  removeItem(key: string): void;
}

/** Logout'ta süpürülen önekler (kullanıcı-bazlı kalıcı durumlar). */
export const USER_LOCAL_STATE_PREFIXES: readonly string[] = [
  "mahir.kpi.",
  "mahir.clients.recent.",
  "mahir.review.",
  "kpi.selection.",
  "kpi.treeCollapsed.",
  "mahir.import.draft",
  // K8 — portal aktif firma seçimi (portal.firm.<userId>)
  "portal.firm.",
];

/** Öneke uyan anahtarları toplar (silmeden; test + çağıran için). */
export function collectUserLocalStateKeys(
  storage: KeyedStorageLike | null | undefined,
  prefixes: readonly string[] = USER_LOCAL_STATE_PREFIXES,
): string[] {
  if (!storage) return [];
  const out: string[] = [];
  try {
    for (let i = 0; i < storage.length; i += 1) {
      const k = storage.key(i);
      if (k && prefixes.some((p) => k.startsWith(p))) out.push(k);
    }
  } catch {
    // private mode / erişim hatası — temizlik atlanır, akış kesilmez
  }
  return out;
}

/**
 * Öneke uyan anahtarları siler ve silinen sayıyı döner. `userId` yalnız iz/okunabilirlik için
 * alınır — temizlik kullanıcıdan bağımsız öneke göre yapılır (kullanıcı-bazlı anahtarların
 * hepsi `<prefix>.<userId>…` biçiminde olduğundan süpürme güvenlidir).
 */
export function clearUserLocalState(
  userId: string | null | undefined,
  storage: KeyedStorageLike | null | undefined = typeof window === "undefined"
    ? null
    : window.localStorage,
): number {
  void userId;
  const keys = collectUserLocalStateKeys(storage);
  let removed = 0;
  for (const k of keys) {
    try {
      storage?.removeItem(k);
      removed += 1;
    } catch {
      // sessiz
    }
  }
  return removed;
}
